// countries
export function getCountryLabelByCode(code) {
  for (let i = 0; i < countries.length; i++) {
    if (countries[i].countryCode == code) {
      return countries[i].labelResource
    }
  }
}

export const countries = [
  { countryCode: 'AL', labelResource: 'country.albania', taxed: false },
  { countryCode: 'DZ', labelResource: 'country.algeria', taxed: false },
  { countryCode: 'AD', labelResource: 'country.andorra', taxed: false },
  { countryCode: 'AO', labelResource: 'country.angola', taxed: false },
  { countryCode: 'AG', labelResource: 'country.antiguaAndBarbuda', taxed: false },
  { countryCode: 'AR', labelResource: 'country.argentina', taxed: false },
  { countryCode: 'AM', labelResource: 'country.armenia', taxed: false },
  { countryCode: 'AU', labelResource: 'country.australia', taxed: true },
  { countryCode: 'AT', labelResource: 'country.austria', taxed: false },
  { countryCode: 'AZ', labelResource: 'country.azerbaijan', taxed: false },
  { countryCode: 'BS', labelResource: 'country.bahamas', taxed: false },
  { countryCode: 'BH', labelResource: 'country.bahrain', taxed: false },
  { countryCode: 'BD', labelResource: 'country.bangladesh', taxed: false },
  { countryCode: 'BB', labelResource: 'country.barbados', taxed: false },
  { countryCode: 'BY', labelResource: 'country.belarus', taxed: false },
  { countryCode: 'BE', labelResource: 'country.belgium', taxed: false },
  { countryCode: 'BZ', labelResource: 'country.belize', taxed: false },
  { countryCode: 'BJ', labelResource: 'country.benin', taxed: false },
  { countryCode: 'BM', labelResource: 'country.bermuda', taxed: false },
  { countryCode: 'BT', labelResource: 'country.bhutan', taxed: false },
  { countryCode: 'BO', labelResource: 'country.bolivia', taxed: false },
  { countryCode: 'BA', labelResource: 'country.bosniaAndHerzegovina', taxed: false },
  { countryCode: 'BW', labelResource: 'country.botswana', taxed: false },
  { countryCode: 'BR', labelResource: 'country.brazil', taxed: false },
  { countryCode: 'BN', labelResource: 'country.bruneiDarussalam', taxed: false },
  { countryCode: 'BG', labelResource: 'country.bulgaria', taxed: false },
  { countryCode: 'BF', labelResource: 'country.burkinaFaso', taxed: false },
  { countryCode: 'KH', labelResource: 'country.cambodia', taxed: false },
  { countryCode: 'CM', labelResource: 'country.cameroon', taxed: false },
  { countryCode: 'CA', labelResource: 'country.canada', taxed: true },
  { countryCode: 'CV', labelResource: 'country.capeVerde', taxed: false },
  { countryCode: 'CF', labelResource: 'country.centralAfricanRepublic', taxed: false },
  { countryCode: 'TD', labelResource: 'country.chad', taxed: false },
  { countryCode: 'CL', labelResource: 'country.chile', taxed: false },
  { countryCode: 'CN', labelResource: 'country.china', taxed: false },
  { countryCode: 'CO', labelResource: 'country.colombia', taxed: false },
  { countryCode: 'CR', labelResource: 'country.costaRica', taxed: false },
  { countryCode: 'HR', labelResource: 'country.croatia', taxed: false },
  { countryCode: 'CY', labelResource: 'country.cyprus', taxed: false },
  { countryCode: 'CZ', labelResource: 'country.czechRepublic', taxed: false },
  { countryCode: 'DK', labelResource: 'country.denmark', taxed: false },
  { countryCode: 'DJ', labelResource: 'country.djibouti', taxed: false },
  { countryCode: 'DM', labelResource: 'country.dominica', taxed: false },
  { countryCode: 'DO', labelResource: 'country.dominicanRepublic', taxed: false },
  { countryCode: 'EC', labelResource: 'country.ecuador', taxed: false },
  { countryCode: 'EG', labelResource: 'country.egypt', taxed: false },
  { countryCode: 'SV', labelResource: 'country.elSalvador', taxed: false },
  { countryCode: 'EE', labelResource: 'country.estonia', taxed: false },
  { countryCode: 'FJ', labelResource: 'country.fiji', taxed: false },
  { countryCode: 'FI', labelResource: 'country.finland', taxed: false },
  { countryCode: 'FR', labelResource: 'country.france', taxed: false },
  { countryCode: 'GF', labelResource: 'country.frenchGuiana', taxed: false },
  { countryCode: 'GA', labelResource: 'country.gabon', taxed: false },
  { countryCode: 'GM', labelResource: 'country.gambia', taxed: false },
  { countryCode: 'GE', labelResource: 'country.georgia', taxed: false },
  { countryCode: 'DE', labelResource: 'country.germany', taxed: false },
  { countryCode: 'GH', labelResource: 'country.ghana', taxed: false },
  { countryCode: 'GR', labelResource: 'country.greece', taxed: false },
  { countryCode: 'GD', labelResource: 'country.grenada', taxed: false },
  { countryCode: 'GT', labelResource: 'country.guatemala', taxed: false },
  { countryCode: 'GW', labelResource: 'country.guineabissau', taxed: false },
  { countryCode: 'GY', labelResource: 'country.guyana', taxed: false },
  { countryCode: 'HT', labelResource: 'country.haiti', taxed: false },
  { countryCode: 'VA', labelResource: 'country.holySeeVaticanCityState', taxed: false },
  { countryCode: 'HN', labelResource: 'country.honduras', taxed: false },
  { countryCode: 'HK', labelResource: 'country.hongKong', taxed: false },
  { countryCode: 'HU', labelResource: 'country.hungary', taxed: false },
  { countryCode: 'IS', labelResource: 'country.iceland', taxed: false },
  { countryCode: 'IN', labelResource: 'country.india', taxed: false },
  { countryCode: 'ID', labelResource: 'country.indonesia', taxed: false },
  { countryCode: 'IQ', labelResource: 'country.iraq', taxed: false },
  { countryCode: 'IE', labelResource: 'country.ireland', taxed: false },
  { countryCode: 'IL', labelResource: 'country.israel', taxed: false },
  { countryCode: 'IT', labelResource: 'country.italy', taxed: false },
  { countryCode: 'JM', labelResource: 'country.jamaica', taxed: false },
  { countryCode: 'JP', labelResource: 'country.japan', taxed: false },
  { countryCode: 'JO', labelResource: 'country.jordan', taxed: false },
  { countryCode: 'KZ', labelResource: 'country.kazakhstan', taxed: false },
  { countryCode: 'KE', labelResource: 'country.kenya', taxed: false },
  { countryCode: 'KI', labelResource: 'country.kiribati', taxed: false },
  { countryCode: 'KR', labelResource: 'country.koreaRepublicOf', taxed: false },
  { countryCode: 'KW', labelResource: 'country.kuwait', taxed: false },
  { countryCode: 'KG', labelResource: 'country.kyrgyzstan', taxed: false },
  { countryCode: 'LA', labelResource: 'country.laos', taxed: false },
  { countryCode: 'LV', labelResource: 'country.latvia', taxed: false },
  { countryCode: 'LB', labelResource: 'country.lebanon', taxed: false },
  { countryCode: 'LS', labelResource: 'country.lesotho', taxed: false },
  { countryCode: 'LR', labelResource: 'country.liberia', taxed: false },
  { countryCode: 'LI', labelResource: 'country.liechtenstein', taxed: false },
  { countryCode: 'LT', labelResource: 'country.lithuania', taxed: false },
  { countryCode: 'LU', labelResource: 'country.luxembourg', taxed: false },
  { countryCode: 'MO', labelResource: 'country.macau', taxed: false },
  { countryCode: 'MK', labelResource: 'country.macedonia', taxed: false },
  { countryCode: 'MG', labelResource: 'country.madagascar', taxed: false },
  { countryCode: 'MW', labelResource: 'country.malawi', taxed: false },
  { countryCode: 'MY', labelResource: 'country.malaysia', taxed: false },
  { countryCode: 'MV', labelResource: 'country.maldives', taxed: false },
  { countryCode: 'ML', labelResource: 'country.mali', taxed: false },
  { countryCode: 'MT', labelResource: 'country.malta', taxed: false },
  { countryCode: 'MH', labelResource: 'country.marshallIslands', taxed: false },
  { countryCode: 'MR', labelResource: 'country.mauritania', taxed: false },
  { countryCode: 'MU', labelResource: 'country.mauritius', taxed: false },
  { countryCode: 'MX', labelResource: 'country.mexico', taxed: false },
  { countryCode: 'FM', labelResource: 'country.micronesiaFederatedStatesOf', taxed: false },
  { countryCode: 'MD', labelResource: 'country.moldovaRepublicOf', taxed: false },
  { countryCode: 'MC', labelResource: 'country.monaco', taxed: false },
  { countryCode: 'MN', labelResource: 'country.mongolia', taxed: false },
  { countryCode: 'ME', labelResource: 'country.montenegro', taxed: false },
  { countryCode: 'MS', labelResource: 'country.montserrat', taxed: false },
  { countryCode: 'MA', labelResource: 'country.morocco', taxed: false },
  { countryCode: 'MZ', labelResource: 'country.mozambique', taxed: false },
  { countryCode: 'NA', labelResource: 'country.namibia', taxed: false },
  { countryCode: 'NR', labelResource: 'country.nauru', taxed: false },
  { countryCode: 'NP', labelResource: 'country.nepal', taxed: false },
  { countryCode: 'NL', labelResource: 'country.netherlands', taxed: false },
  { countryCode: 'NZ', labelResource: 'country.newZealand', taxed: false },
  { countryCode: 'NI', labelResource: 'country.nicaragua', taxed: false },
  { countryCode: 'NE', labelResource: 'country.niger', taxed: false },
  { countryCode: 'NG', labelResource: 'country.nigeria', taxed: false },
  { countryCode: 'NO', labelResource: 'country.norway', taxed: false },
  { countryCode: 'OM', labelResource: 'country.oman', taxed: false },
  { countryCode: 'PK', labelResource: 'country.pakistan', taxed: false },
  { countryCode: 'PW', labelResource: 'country.palau', taxed: false },
  { countryCode: 'PA', labelResource: 'country.panama', taxed: false },
  { countryCode: 'PG', labelResource: 'country.papuaNewGuinea', taxed: false },
  { countryCode: 'PY', labelResource: 'country.paraguay', taxed: false },
  { countryCode: 'PE', labelResource: 'country.peru', taxed: false },
  { countryCode: 'PH', labelResource: 'country.philippines', taxed: false },
  { countryCode: 'PL', labelResource: 'country.poland', taxed: false },
  { countryCode: 'PT', labelResource: 'country.portugal', taxed: false },
  { countryCode: 'QA', labelResource: 'country.qatar', taxed: false },
  { countryCode: 'RO', labelResource: 'country.romania', taxed: false },
  { countryCode: 'RU', labelResource: 'country.russianFederation', taxed: false },
  { countryCode: 'RW', labelResource: 'country.rwanda', taxed: false },
  { countryCode: 'KN', labelResource: 'country.saintKittsAndNevis', taxed: false },
  { countryCode: 'LC', labelResource: 'country.saintLucia', taxed: false },
  { countryCode: 'VC', labelResource: 'country.saintVincentAndTheGrenadines', taxed: false },
  { countryCode: 'WS', labelResource: 'country.samoa', taxed: false },
  { countryCode: 'SM', labelResource: 'country.sanMarino', taxed: false },
  { countryCode: 'ST', labelResource: 'country.saoTomeAndPrincipe', taxed: false },
  { countryCode: 'SA', labelResource: 'country.saudiArabia', taxed: false },
  { countryCode: 'SN', labelResource: 'country.senegal', taxed: false },
  { countryCode: 'RS', labelResource: 'country.serbia', taxed: false },
  { countryCode: 'SC', labelResource: 'country.seychelles', taxed: false },
  { countryCode: 'SL', labelResource: 'country.sierraLeone', taxed: false },
  { countryCode: 'SG', labelResource: 'country.singapore', taxed: false },
  { countryCode: 'SK', labelResource: 'country.slovakia', taxed: false },
  { countryCode: 'SI', labelResource: 'country.slovenia', taxed: false },
  { countryCode: 'SB', labelResource: 'country.solomonIslands', taxed: false },
  { countryCode: 'ZA', labelResource: 'country.southAfrica', taxed: false },
  { countryCode: 'ES', labelResource: 'country.spain', taxed: false },
  { countryCode: 'LK', labelResource: 'country.sriLanka', taxed: false },
  { countryCode: 'SR', labelResource: 'country.suriname', taxed: false },
  { countryCode: 'SZ', labelResource: 'country.swaziland', taxed: false },
  { countryCode: 'SE', labelResource: 'country.sweden', taxed: false },
  { countryCode: 'CH', labelResource: 'country.switzerland', taxed: false },
  { countryCode: 'TJ', labelResource: 'country.tajikistan', taxed: false },
  { countryCode: 'TW', labelResource: 'country.taiwanProvinceOfChina', taxed: false },
  { countryCode: 'TZ', labelResource: 'country.tanzaniaUnitedRepublicOf', taxed: false },
  { countryCode: 'TH', labelResource: 'country.thailand', taxed: false },
  { countryCode: 'TL', labelResource: 'country.timorleste', taxed: false },
  { countryCode: 'TG', labelResource: 'country.togo', taxed: false },
  { countryCode: 'TO', labelResource: 'country.tonga', taxed: false },
  { countryCode: 'TT', labelResource: 'country.trinidadAndTobago', taxed: false },
  { countryCode: 'TN', labelResource: 'country.tunisia', taxed: false },
  { countryCode: 'TR', labelResource: 'country.turkey', taxed: false },
  { countryCode: 'TM', labelResource: 'country.turkmenistan', taxed: false },
  { countryCode: 'TV', labelResource: 'country.tuvalu', taxed: false },
  { countryCode: 'UG', labelResource: 'country.uganda', taxed: false },
  { countryCode: 'UA', labelResource: 'country.ukraine', taxed: false },
  { countryCode: 'AE', labelResource: 'country.unitedArabEmirates', taxed: false },
  { countryCode: 'GB', labelResource: 'country.unitedKingdom', taxed: false },
  { countryCode: 'US', labelResource: 'country.unitedStates', taxed: true },
  { countryCode: 'UY', labelResource: 'country.uruguay', taxed: false },
  { countryCode: 'UZ', labelResource: 'country.uzbekistan', taxed: false },
  { countryCode: 'VU', labelResource: 'country.vanuatu', taxed: false },
  { countryCode: 'VE', labelResource: 'country.venezuela', taxed: false },
  { countryCode: 'VN', labelResource: 'country.vietNam', taxed: false },
  { countryCode: 'YE', labelResource: 'country.yemen', taxed: false },
  { countryCode: 'ZM', labelResource: 'country.zambia', taxed: false },
  { countryCode: 'ZW', labelResource: 'country.zimbabwe', taxed: false },
]

export const usStates = [
  { value: 'AL', label: 'Alabama' },
  { value: 'AK', label: 'Alaska' },
  { value: 'AZ', label: 'Arizona' },
  { value: 'AR', label: 'Arkansas' },
  { value: 'CA', label: 'California' },
  { value: 'CO', label: 'Colorado' },
  { value: 'CT', label: 'Connecticut' },
  { value: 'DE', label: 'Delaware' },
  { value: 'DC', label: 'District of Columbia' },
  { value: 'FL', label: 'Florida' },
  { value: 'GA', label: 'Georgia' },
  { value: 'HI', label: 'Hawaii' },
  { value: 'ID', label: 'Idaho' },
  { value: 'IL', label: 'Illinois' },
  { value: 'IN', label: 'Indiana' },
  { value: 'IA', label: 'Iowa' },
  { value: 'KS', label: 'Kansas' },
  { value: 'KY', label: 'Kentucky' },
  { value: 'LA', label: 'Louisiana' },
  { value: 'ME', label: 'Maine' },
  { value: 'MD', label: 'Maryland' },
  { value: 'MA', label: 'Massachusetts' },
  { value: 'MI', label: 'Michigan' },
  { value: 'MN', label: 'Minnesota' },
  { value: 'MS', label: 'Mississippi' },
  { value: 'MO', label: 'Missouri' },
  { value: 'MT', label: 'Montana' },
  { value: 'NE', label: 'Nebraska' },
  { value: 'NV', label: 'Nevada' },
  { value: 'NH', label: 'New Hampshire' },
  { value: 'NJ', label: 'New Jersey' },
  { value: 'NM', label: 'New Mexico' },
  { value: 'NY', label: 'New York' },
  { value: 'NC', label: 'North Carolina' },
  { value: 'ND', label: 'North Dakota' },
  { value: 'OH', label: 'Ohio' },
  { value: 'OK', label: 'Oklahoma' },
  { value: 'OR', label: 'Oregon' },
  { value: 'PA', label: 'Pennsylvania' },
  { value: 'RI', label: 'Rhode Island' },
  { value: 'SC', label: 'South Carolina' },
  { value: 'SD', label: 'South Dakota' },
  { value: 'TN', label: 'Tennessee' },
  { value: 'TX', label: 'Texas' },
  { value: 'UT', label: 'Utah' },
  { value: 'VT', label: 'Vermont' },
  { value: 'VA', label: 'Virginia' },
  { value: 'WA', label: 'Washington' },
  { value: 'WV', label: 'West Virginia' },
  { value: 'WI', label: 'Wisconsin' },
  { value: 'WY', label: 'Wyoming' },
]

// A list of states plus Puerto Rico
export const usStatesPlusPR = usStates
  .slice(0, 39)
  .concat([{ value: 'PR', label: 'Puerto Rico' }])
  .concat(usStates.slice(39, 51))

// List of stats in Canada
export const canadaStates = [
  { value: 'AB', label: 'Alberta' },
  { value: 'BC', label: 'British Columbia' },
  { value: 'MB', label: 'Manitoba' },
  { value: 'NB', label: 'New Brunswick' },
  { value: 'NL', label: 'Newfoundland and Labrador' },
  { value: 'NS', label: 'Nova Scotia' },
  { value: 'NT', label: 'Northwest Territories' },
  { value: 'NU', label: 'Nunavut' },
  { value: 'ON', label: 'Ontario' },
  { value: 'PE', label: 'Prince Edward Island' },
  { value: 'QC', label: 'Quebec' },
  { value: 'SK', label: 'Saskatchewan' },
  { value: 'YT', label: 'Yukon' },
]
